import Button from '@klv/atoms/button';
import type { TColorVariant } from '@klv/shared/styles/types';
import { setButtonAriaLabel } from '@klv/atoms/button/utils/functions';
import Image from '@klv/atoms/image';
import { getColorVariantFromBackground } from '@klv/shared/utils/functions';
import * as s from './styles';
import type { IImageLink, IImageLinkValues } from './types';

const ConditionalImageLink = ({ backgroundColor, linkValues, children }: { backgroundColor: TColorVariant; linkValues?: IImageLinkValues; children: React.ReactElement; }) => (
  linkValues?.link?.[0]?.linkLabel && linkValues.link[0]?.url
    ? (
      <Button
        aria-hidden={!!linkValues.link[0].linkLabel}
        aria-label={setButtonAriaLabel({ openInNewTab: linkValues.link[0].openInNewTab, text: linkValues.link[0].linkLabel })}
        buttonColor={getColorVariantFromBackground(backgroundColor)}
        openInNewTab={linkValues.link[0].openInNewTab}
        setTabIndex={linkValues.link[0].linkLabel ? 0 : -1}
        text=""
        url={linkValues.link[0].url}
        variant="none"
      >
        {children}
      </Button>
    )
    : children
);

const ImageLink = ({
  backgroundColor,
  image,
  imageLink,
  loading,
  ...rest
}: IImageLink) => {
  if (image?.gatsbyImage) {
    return (
      <s.StyledImageLink {...rest}>
        <ConditionalImageLink backgroundColor={backgroundColor} linkValues={imageLink}>
          <Image altText={image?.altText} imageData={image.gatsbyImage} loading={loading} />
        </ConditionalImageLink>
      </s.StyledImageLink>
    );
  }

  return null;
};

export default ImageLink;
